<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Non CTC Reimbursement
    </div>
    <form name="ReimbursementForm" (ngSubmit)="Validate(ReimbursementForm)" #ReimbursementForm="ngForm" class="pb-2"
        novalidate>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4 px-1">
                        <label class="form-font-label">Reimbursement Type <span class="text-danger">*</span></label>
                        <ng-select name="Reimbursementtype" id="Reimbursementtype" [items]="ReimbursementLoad"
                            bindLabel="ReimbursementType" bindValue="ESS_ReimbursementTypeID"
                            (change)="onSelectChange('ReimbursementType');ComboLoad('OpenMonthYear');"
                            [(ngModel)]="Reimbursement.ESS_ReimbursementTypeId" #Reimbursementtype="ngModel"
                            placeholder="Select Reimbursement type" required>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select Reimbursement Type!
                        </div>
                    </div>

                    <div class="col-md-3 px-1">
                        <label class="form-font-label">Total Bill Amount <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" maxlength="20" id="TotalBillAmount"
                            name="TotalBillAmount" [(ngModel)]="Reimbursement.BillAmount" #TotalBillAmount="ngModel"
                            required style="text-align: right;" (keypress)="validate($event,'billamount')">
                        <div class="invalid-feedback">
                            Please Enter Bill Amount!
                        </div>
                    </div>
                    <div class="col-md-3 px-1">
                        <label class="form-font-label">Total Claim Amount <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" maxlength="20" id="TotalClaimAmount"
                            name="TotalClaimAmount" [(ngModel)]="Reimbursement.ClaimedAmount"
                            #TotalClaimAmount="ngModel" required style="text-align: right;"
                            (keypress)="validate($event,'claimamount')">
                        <div class="invalid-feedback">
                            Please Enter Claim Amount!
                        </div>
                    </div>
                    <!-- <div class="col-md-3 px-1" *ngIf="Filter.Type !== 'Request'">
                        <label class="Label">Month and Year</label>
                        <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year"
                            (navigate)="selectedMonth= $event.next;onNavigate()" name="dateselect"
                            style="width: 100%;"></ngb-datepicker>
                    </div> -->
                    <!-- <div class="col-md-3 px-1" *ngIf="Filter.Type === 'Request'"><br>
                        <div class="input-group">
                            <input type="text" class="form-control" id="selectedMonth" name="selectedMonth"
                                [(ngModel)]="Reimbursement.selectedMonth" disabled>
                            &nbsp;&nbsp;<input type="text" class="form-control" id="selectedYear" name="selectedYear"
                                [(ngModel)]="Reimbursement.selectedYear" disabled>
                        </div>
                    </div>
                    <div class="col-md-3 px-1" *ngIf="Filter.Type === 'Request'">
                        <label class="Label">Total Outstanding</label>
                        <input type="text" class="form-control" id="TotalOutstanding" name="TotalOutstanding"
                            [(ngModel)]="Reimbursement.OutstandingAmount" #TotalOutstanding="ngModel" required disabled
                            style="text-align: right;">
                    </div>
                    <div class="col-md-3 px-1" *ngIf="Filter.Type === 'History'"><br>
                        <button type="button" name="button" class="btn btn-primary" [disabled]="isDisabled"
                            (click)="Apply()"><i class="bi bi-cloud-download me-2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply':'Loading...'}}</button>
                    </div> -->
                </div>
                <div class="row mt-2" *ngIf="Filter.Type === 'Request'">
                    <div class="col-md-3 px-1">
                        <label class="Label">Bill Date<span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="BillDate"
                                [(ngModel)]="Reimbursement.BillDate" ngbDatepicker #BillDate="ngbDatepicker" required />
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                (click)="BillDate.toggle()"></button>
                            <div class="invalid-feedback">
                                Enter Bill Date!
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 px-1">
                        <label class="Label">From Date<span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="FromDate"
                                [(ngModel)]="Reimbursement.BillFromDate" ngbDatepicker #FromDate="ngbDatepicker"
                                required />
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                (click)="FromDate.toggle()"></button>
                            <div class="invalid-feedback">
                                Enter Amount From!
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 px-1">
                        <label class="Label">To Date<span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="Date"
                                [(ngModel)]="Reimbursement.BillToDate" ngbDatepicker #ToDate="ngbDatepicker" required />
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                (click)="ToDate.toggle()"></button>
                            <div class="invalid-feedback">
                                Enter Amount To!
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="Filter.Type === 'Request'">
                    <div class="col-md-6 px-1">
                        <label for="Reason" class="form-font-label">Remark</label>
                        <input type="text" class="form-control" id="Reason" name="Reason"
                            [(ngModel)]="Reimbursement.Remark" #Reason="ngModel">
                        <div class="invalid-feedback">
                            Please enter Remark!
                        </div>
                    </div>

                    <div class="col-md-5 px-1">
                        <label class="form-font-label">File Upload</label>
                        <div class="file-input-container">
                            <input class="form-control form-control-sm" id="formFileSm" type="file"
                                *ngIf="!Reimbursement.Attachment" (change)="onFileSelected($event)"
                                accept=".pdf,image/*" />
                            <span *ngIf="Reimbursement.Attachment" class="file-name">{{ Reimbursement.Attachment
                                }}</span>
                            <span *ngIf="Reimbursement.Attachment "> <button class="btn btn-sm" name="view"
                                    type="button" style="color: blue;" (click)="viewFile()"><i
                                        class="bi bi-eye"></i></button></span>
                            <button class="btn btn-sm" name="delete" type="button" *ngIf="Reimbursement.Attachment"
                                (click)="removeFile()">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="Filter.Type === 'Request'">
                    <!-- <div class="col-md-4 px-1">
                        <label class="form-font-label">File Upload <span class="text-danger">*</span></label>
                        <div class="file-input-container">
                            <input class="form-control form-control-sm" id="formFileSm" type="file"
                                *ngIf="!Reimbursement.Attachment" (change)="onFileSelected($event)"
                                accept=".pdf,image/*" />
                            <span *ngIf="Reimbursement.Attachment" class="file-name">{{ Reimbursement.Attachment
                                }}</span>
                            <span *ngIf="Reimbursement.Attachment "> <button class="btn btn-sm" name="view"
                                    type="button" style="color: blue;" (click)="viewFile()"><i
                                        class="bi bi-eye"></i></button></span>
                            <button class="btn btn-sm" name="delete" type="button" *ngIf="Reimbursement.Attachment"
                                (click)="removeFile()">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>
            <!-- <div class="card border-radius-0 mt-1 p-0" *ngIf="Filter.Type === 'History'">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Particulars</th>
                                <th *ngFor="let header of getHeaders()" scope="col">{{ header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of ReimbursementHistory; let i = index">
                                <th scope="row">{{ i + 1 }}</th>
                                <td>{{ site['Particulars'] }}</td>
                                <td *ngFor="let header of getHeaders()">{{ site[header] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary" [disabled]="isDisabled" (click)="close()"><i
                        class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" name="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="Filter.Type === 'Request'"><i class="bi bi-pass" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>